import { BitkitNativeSelect, BitkitNativeSelectProps } from '@bitrise/bitkit-v2';
import { getNames } from 'country-list';
import { forwardRef } from 'react';

export type CountrySelectorProps = Omit<BitkitNativeSelectProps, 'children'>;

const COUNTRIES = getNames().sort();

const CountrySelector = forwardRef<HTMLSelectElement, CountrySelectorProps>((props, ref) => {
  return (
    <BitkitNativeSelect label="Country" placeholder="Select country" {...props} ref={ref}>
      {COUNTRIES.map((name) => {
        return (
          <option key={name} value={name}>
            {name}
          </option>
        );
      })}
    </BitkitNativeSelect>
  );
});

CountrySelector.displayName = 'CountrySelector';

export default CountrySelector;
